// jQuery (loaded from CDN)
const $ = window.jQuery;

// Vendor
import './vendor/imgix';
import './vendor/countdown';

// Foundation 5
import 'foundation-sites/js/foundation/foundation';
import 'foundation-sites/js/foundation/foundation.accordion';
import 'foundation-sites/js/foundation/foundation.reveal';

// Other vendors
import Flickity from 'flickity';
import Cookies from 'js-cookie';

window.Flickity = Flickity;
window.Cookies = Cookies;

// Alpine.js
import Alpine from 'alpinejs';

import basketStore from './stores/basket.js';
import filtersStore from './stores/filters.js';

import basket from './components/shared/basket.js';
import tooltip from './components/shared/tooltip.js';

import announcement from './components/storefront/announcement.js';
import checkout from './components/storefront/checkout.js';
import checkoutStatus from './components/storefront/checkout-status.js';
import corporateOrder from './components/storefront/corporate-order.js';
import extension from './components/storefront/extension.js';
import hero from './components/storefront/hero.js';
import paymentLink from './components/storefront/payment-link.js';
import voucher from './components/storefront/voucher.js';
import voucherFilter from './components/storefront/voucher-filter.js';

window.Alpine = Alpine;

Alpine.store('basket', basketStore);
Alpine.store('filters', filtersStore);

Alpine.data('basket', basket);
Alpine.data('tooltip', tooltip);

Alpine.data('announcement', announcement);
Alpine.data('checkout', checkout);
Alpine.data('checkoutStatus', checkoutStatus);
Alpine.data('corporateOrder', corporateOrder);
Alpine.data('extension', extension);
Alpine.data('hero', hero);
Alpine.data('paymentLink', paymentLink);
Alpine.data('voucher', voucher);
Alpine.data('voucherFilter', voucherFilter);

Alpine.start();

document.addEventListener('wheel', (e) => {
    if (e.target.type === 'number') {
        e.target.blur();
    }
}, { passive: true });

// Patch Foundation 5 Reveal for jQuery 3 compatibility.
// Foundation 5 checks `target.selector` (removed in jQuery 3) to decide
// how to locate the modal. Without this patch, clicking a [data-reveal-id]
// trigger silently fails because the open() method falls through to using
// `document` as the modal element instead of looking up the target by ID.
if (window.Foundation && Foundation.libs && Foundation.libs.reveal) {
    const originalOpen = Foundation.libs.reveal.open;

    Foundation.libs.reveal.open = function (target, ajaxSettings) {
        if (target && typeof target.selector === 'undefined') {
            target.selector = '';
        }

        return originalOpen.call(this, target, ajaxSettings);
    };
}

// Initialize Foundation
$(document).foundation();

// imgix lazy-loading
window.imgix.onready(function () {
    const fluidDefaults = {
        lazyLoad: true,
        lazyLoadOffsetVertical: 150,
        updateOnResizeDown: true,
        pixelStep: 10,
        autoInsertCSSBestPractices: true,

        onChangeParamOverride: function (w, h, params) {
            params.auto = 'format';
            params.ch = 'DPR,Width';
            params.w = w;
            params.h = h;

            return params;
        },

        onLoad: function (el) {
            $(el).addClass('has-loaded');
        },
    };

    window.imgix.fluid(fluidDefaults);

    $(window).on('images.gifted', function () {
        window.imgix.fluid(fluidDefaults);
    });

    const sliderEl = $('.js-flickity');

    sliderEl.on('change.flickity', function (event, index) {
        const current = $(this).find('.js-flickity-cell').eq(index);
        const next = $(this).find('.js-flickity-cell').eq(index + 1);

        if (current.length) {
            window.imgix.fluid(current[0], fluidDefaults);
        }

        if (next.length) {
            setTimeout(function () {
                window.imgix.fluid(next[0], fluidDefaults);
            }, 750);
        }
    });

    sliderEl.each(function () {
        $(this).trigger('change.flickity', [0]);
    });
});

document.addEventListener('keypress', function (e) {
    if (e.key !== 'Enter') return;
    if (!e.target.classList.contains('voucher-message-field')) return;

    e.preventDefault();

    const fields = document.querySelectorAll('.voucher-message-field');
    const index = Array.prototype.indexOf.call(fields, e.target);

    if (fields[index + 1]) {
        fields[index + 1].focus();
    }
});
